
import { defineComponent, reactive, Ref, ref } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import InputText from "@/components/primevueCustom/InputText.vue";
import Button from "primevue/button";
// import Message from "primevue/message";
import $API from "@/services";
import { useI18n } from "vue-i18n";
import { IMessage, messageType } from "@/models/message";
import { IAlert } from "@/models/common";
import { CommonMutationTypes } from "@/store/modules/common/mutations";
import { useStore } from "@/store";
import router from "@/router";

export default defineComponent({
  name: "Forgot Password",
  setup() {
    const email = ref("");
    const error = ref("");
    const { t } = useI18n({ useScope: "global" });
    const { t: l } = useI18n();

    const store = useStore();

    const state = reactive({
      message: {} as IMessage,
    });

    const alert: Ref<IAlert> = ref({
      type: messageType.ERROR,
      content: "",
    });

    return { email, error, t, l, state, alert, store };
  },
  methods: {
    async forgetPassword() {
      try {
        this.store.commit(CommonMutationTypes.SET_IS_LODING, true);
        const success = await $API.SignService.forgetPassword(this.email.valueOf());

        if (success) {
          this.alert = {
            title: this.t('forgotPassword'),
            content: this.t("EmailSendOK"),
            type: messageType.INFO,
            callback: () => {
              router.replace("/");
            },
          };
        }  
      } catch (e:any) {
        console.error(e);
        this.alert = {
          content: e.ResultData,
          type: messageType.ERROR,
        };
      } finally {
        this.store.commit(CommonMutationTypes.SET_IS_LODING, false);
      }
    },
  },
  components: {
    Form,
    Field,
    ErrorMessage,
    InputText,
    Button
  },
});
